import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconSelectWithFrame.tsx
const IconSelectWithFrame = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsxs("g", {
			fill: "currentColor",
			clipPath: "url(#a)",
			children: [/* @__PURE__ */ jsx("path", { d: "M3 3h2v2H3zM7 3h2v2H7zM11 3h2v2h-2zM15 3h2v2h-2zM19 3h2v2h-2zM19 7h2v2h-2zM19 11h2v2h-2zM3 7h2v2H3zM3 11h2v2H3zM3 15h2v2H3zM3 19h2v2H3zM7 19h2v2H7z" }), /* @__PURE__ */ jsx("path", {
				fillRule: "evenodd",
				d: "m13.34 11.93-.62 5.505 1.717-1.13 1.863 5.118.94-.342-1.863-5.118 2.041-.238zm4.781 5.727 3.828-.447L11.8 7.762l-1.545 13.69 3.169-2.085 1.681 4.62 4.699-1.71z",
				clipRule: "evenodd"
			})]
		}),
		/* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ jsx("path", {
				fill: "#fff",
				d: "M0 0h24v24H0z"
			})
		}) })
	]
});
var IconSelectWithFrame_default = forwardRef(IconSelectWithFrame);
//#endregion
export { IconSelectWithFrame_default as default };
